export default __webpack_public_path__ + "static/python-4d83351cdbaa92cca2ce1250b8eaa1cf.png";